(function() {
    const bubble = document.getElementById('sk-chat-bubble');
    const toggle = document.getElementById('sk-chat-bubble-toggle');
    const close = document.getElementById('sk-chat-bubble-close');
    const iframeContainer = document.getElementById('sk-chat-bubble-iframe-container');
    const loadingElement = document.getElementById('sk-chat-bubble-loading');
    const iframeHasCloseButton = bubble && bubble.getAttribute('data-iframe-has-close-button') === 'true';
    let iframeLoaded = false;
    let iframeReady = false;
    let closeButtonAvailable = !iframeHasCloseButton;
    let chatIframe = null;

    // Cookie helpers
    function setChatCookie() {
        let d = new Date();
        d.setTime(d.getTime() + (60*60*1000)); // 1 hour
        document.cookie = "sk-chat-open=1;expires=" + d.toUTCString() + ";path=/";
    }
    function getChatCookie() {
        const name = "sk-chat-open=";
        const ca = document.cookie.split(';');
        for(let i=0; i<ca.length; i++) {
            const c = ca[i].trim();
            if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
        }
        return null;
    }
    function deleteChatCookie() {
        document.cookie = "sk-chat-open=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    function decodeHtmlEntities(str) {
        const div = document.createElement('div');
        div.innerHTML = str;
        return div.textContent;
    }

    function showLoading() {
        if (loadingElement) {
            loadingElement.style.display = 'flex';
        }
    }

    function hideLoading() {
        if (loadingElement) {
            loadingElement.style.display = 'none';
        }
    }

    function syncCloseButton() {
        if (!close) return;
        const isOpen = bubble.classList.contains('sk-chat-bubble--open');
        close.style.display = (isOpen && closeButtonAvailable) ? 'block' : 'none';
    }

    // Siste utvei: laster ikke iframen, er iframens egen lukkeknapp heller ikke der
    function enableCloseButtonFallback() {
        closeButtonAvailable = true;
        syncCloseButton();
    }

    function loadIframe() {
        if (!iframeLoaded && bubble && iframeContainer) {
            const iframeCodeEncoded = bubble.getAttribute('data-iframe-code');
            if (iframeCodeEncoded) {
                showLoading();
                
                const iframeCode = decodeHtmlEntities(iframeCodeEncoded);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = iframeCode;
                const iframeElement = tempDiv.firstChild;
                
                if (iframeElement && iframeElement.tagName === 'IFRAME') {
                    iframeElement.addEventListener('load', function() {
                        iframeReady = true;
                        hideLoading();
                    });
                    
                    setTimeout(() => {
                        hideLoading();
                        if (!iframeReady) {
                            enableCloseButtonFallback();
                        }
                    }, 10000);

                    chatIframe = iframeElement;
                }
                
                iframeContainer.insertBefore(iframeElement, close);
                iframeLoaded = true;
                
                if (!iframeElement || iframeElement.tagName !== 'IFRAME') {
                    hideLoading();
                    enableCloseButtonFallback();
                }
            }
        }
    }

    function openBubble(persist, moveFocus) {
        bubble.classList.add('sk-chat-bubble--open');
        bubble.classList.remove('sk-chat-bubble--closed');
        toggle.classList.add('sk-chat-bubble__toggle--hidden');
        toggle.setAttribute('aria-expanded', 'true');
        syncCloseButton();
        if (persist) {
            setChatCookie();
        }
        loadIframe();
        // Launcheren blir visibility: hidden, så fokus må inn i dialogen for ikke å havne på <body>
        if (moveFocus && iframeContainer) {
            iframeContainer.focus();
        }
    }

    function closeBubble() {
        bubble.classList.remove('sk-chat-bubble--open');
        bubble.classList.add('sk-chat-bubble--closed');
        toggle.classList.remove('sk-chat-bubble__toggle--hidden');
        toggle.setAttribute('aria-expanded', 'false');
        syncCloseButton();
        deleteChatCookie();
    }
    
    if (bubble && toggle) {
        // On load: open if cookie is set
        if (getChatCookie() === "1") {
            openBubble(false, false);
        }
        
        toggle.addEventListener('click', function() {
            if (bubble.classList.contains('sk-chat-bubble--open')) {
                closeBubble();
            } else {
                openBubble(true, true);
            }
        });
        
        if (close) {
            close.addEventListener('click', function() {
                closeBubble();
                toggle.focus();
            });
        }

        window.addEventListener('message', function(event) {
            // event.source pinner meldingen til akkurat vår iframe, som er nok — en origin-
            // sjekk i tillegg røk hvis iframens URL videresendte (http→https, annen host,
            // kortlenke) og gjorde chatten umulig å lukke.
            if (!chatIframe || event.source !== chatIframe.contentWindow) return;

            const data = event.data;
            if (!data || data.source !== 'innbyggeragent' || data.action !== 'close') return;

            closeBubble();
            toggle.focus();
        });

        document.addEventListener('keydown', function(event) {
            if (event.key !== 'Escape') return;
            if (!bubble.classList.contains('sk-chat-bubble--open')) return;
            // Escape skal bare treffe chatten når fokus faktisk står i den
            if (!bubble.contains(document.activeElement)) return;

            closeBubble();
            toggle.focus();
        });
    }
})();
